import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsDefined, IsNumber } from "class-validator";

export class UserRoleCanClaimTripsDetail {
    @IsDefined()
    @IsBoolean()
    @Expose()
    public canSeeAssignedOrders: boolean;

    @IsDefined()
    @IsNumber()
    @Expose()
    public maxOrderPrice: number;

    @IsDefined()
    @IsNumber()
    @Expose()
    public maxDaysBeforeTrip: number;

    @IsArray()
    @IsDefined()
    @Expose()
    public countryIdsForClaiming: Array<string>;
}
